import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const FilterComponentSelector = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: ${({ isRadio }) => (isRadio ? '28px' : '')};
    padding-right: ${({ isRadio }) => (isRadio ? '28px' : '')};
    padding-bottom: ${({ isRadio, paddingBottom }) =>
        isRadio ? (paddingBottom ? paddingBottom : 'unset') : ''};
    margin-bottom: ${({ isCheckbox, marginBottom }) =>
        isCheckbox && marginBottom ? marginBottom : ''};
    &:hover {
        cursor: pointer;
    }
`;

export const FilterComponentLabels = styled.label`
    display: flex;
    padding-left: ${({ isCheckbox, leftPadding }) =>
        isCheckbox ? (leftPadding ? leftPadding : '28px') : '0px'};
    min-width: ${({ isCheckbox }) => (isCheckbox ? '0' : '')};
    padding-right: ${({ isCheckbox }) => (isCheckbox ? '17px' : '0px')};
    font-family: ${({ isCheckbox }) =>
        isCheckbox ? 'AvenirNextWorld Demi' : 'AvenirNextWorld Regular'};
    width: 100%;
    font-size: ${({ isCheckbox }) => (isCheckbox ? '14px' : '15px')};
    align-items: center;
    &:hover {
        cursor: pointer;
    }
    ${media.smalDevice`
		width: ${({ isCheckbox, labelResponsiveWidth }) =>
            isCheckbox
                ? labelResponsiveWidth
                    ? labelResponsiveWidth
                    : '100%'
                : '100vw'};
		max-width: none;
    `}
`;

export const CheckBox = styled.img`
    width: 20px;
    height: 20px;
    min-width: 20px;
    margin-right: ${(props) =>
        props.rightMargin ? props.rightMargin : '25px'};
`;

export const FilterCheckbox = styled.input`
    margin: 0 !important;
    display: none;
`;

export const RadioButton = styled.img`
    width: 20px;
    height: 20px;
    min-width: 20px;
    margin-right: 25px;
`;

export const FilterLabel = styled.div`
    display: ${({ isCheckbox }) => (isCheckbox ? 'flex' : '')};
    text-align: left;
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Regular'};
    letter-spacing: -0.12px;
    color: ${({ fontColor }) => (fontColor ? fontColor : '#000000')};
    margin-top: 0px;
    margin-bottom: 0px;
    width: ${({ width, isCheckbox }) =>
        width ? width : isCheckbox ? '85%' : 'unset'};
    align-items: center;
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '15px')};
    word-break: break-word !important;
    word-break: break-all;
    white-space: ${({ whiteSpace, isRadio }) =>
        isRadio ? (whiteSpace ? whiteSpace : 'unset') : ''};
    overflow: ${({ overFlow, isRadio }) =>
        isRadio ? (overFlow ? overFlow : 'unset') : ''};
    text-overflow: ${({ textOverflow, isRadio }) =>
        isRadio ? (textOverflow ? textOverflow : 'unset') : ''};

    ${media.smalDevice`
        width: ${({ isCheckbox, labelWidth }) =>
            isCheckbox ? (labelWidth ? labelWidth : '85%') : ''};
    `}
    ${media.mobileDevice`
        width: ${({ isCheckbox, labelMbWidth }) =>
            isCheckbox ? (labelMbWidth ? labelMbWidth : '90%') : ''};
    `}

    @media only screen and (max-device-width: 360px) {
        width: ${({ smbWidth, isRadio }) => (isRadio ? smbWidth : '')};
    }
`;

export const OrderStatusIcons = styled.img`
    width: 24px;
    height: 24px;
    margin-right: 15px;
    &:hover {
        cursor: pointer;
    }
`;

export const DefaultIndicator = styled.div`
    font-family: AvenirNextWorld Regular;
    font-size: 10px;
    color: #e5047e;
    border: 1px solid #e5047e;
    border-radius: ${({ isCheckbox }) => (isCheckbox ? '4px' : '3px')};
    width: ${({ width }) => (width ? width : '47px')};
    height: 18px;
    display: flex;
    justify-content: center;
    padding: ${({ isCheckbox }) => (isCheckbox ? '0 5px' : '')};
    margin-left: ${({ isCheckbox }) => (isCheckbox ? '20px' : '10px')};
    opacity: ${({ isCheckbox }) => (isCheckbox ? '1' : '')};
    white-space: nowrap;
`;

export const LineSeparator = styled.hr`
    border: 0;
    border-top: 1px solid #eee;
    box-sizing: content-box;
    height: 0;
    overflow: visible;
`;
